import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from "vuex";
import { ref, computed } from "vue";
import type { Stipulation } from "@/models/opal";
import NextButton from "@/components/shared/NextButton.vue";
import AddressFormsModal from "@/components/checklist/address-mismatch/AddressFormsModal.vue";
import useHtmlUtilities from "@/use/htmlUtilities";
import type { Applicant, Address } from "@/models/application";
import { formatAddress } from "@/composables/forms/useAddressForm";
import { AddressTypeIds, StipulationStatusIds } from "@/config/constants";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressMismatch',
  props: {
    stip: {},
    applicant: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const { decodeHTMLEncodedStr } = useHtmlUtilities();

const emit = __emit;

const addressFormsModal = ref<InstanceType<typeof AddressFormsModal> | null>();

const previousAddresses = computed(() => getPreviousAddresses());

function openAddressModal() {
  console.log(`${props.applicant.id} addressMismatch`, props.stip);
  store.state.forms.addressForm.applicantId = props.applicant?.id;
  store.state.forms.addressForm.stipulationId = props.stip?.id;
  store.dispatch("forms/setStipulation", props.stip);
  store.dispatch("modal/openAddressModal");
}

function closeAddressModal() {
  store.dispatch("forms/setStipulation", {});
  store.dispatch("modal/closeAddressModal");
  store.dispatch("forms/getApplicantAddressesAsync", props.applicant?.id);
}

function handleSuccess() {
  const updatedStip = {
    ...props.stip,
    stipulationStatusId: StipulationStatusIds.PENDING,
    stipulationStatusName: "Pending",
  };
	
  emit("success", updatedStip);
  closeAddressModal();
}

function getPreviousAddresses() {
  let applicantAddresses = store.state.appData.applicants
    .find((a: Applicant) => a.id === props.stip?.applicantId)
    ?.addresses?.filter((a: Address) => a.addressTypeId === AddressTypeIds.PreviousAddress);

  if (applicantAddresses && applicantAddresses.length > 0) {
    applicantAddresses.forEach((a: Address) => {
      a.address1 = decodeHTMLEncodedStr(a.address1);
      a.address2 = decodeHTMLEncodedStr(a.address2);
      a.city = decodeHTMLEncodedStr(a.city);
    });
  }

  return applicantAddresses || [];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Previous Addresses")
        ])
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previousAddresses.value, (address, index) => {
        return (_openBlock(), _createElementBlock("tbody", { key: index }, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_unref(formatAddress)(address, _unref(store).state.lookupsModule?.lookups?.addressUnits)), 1),
            _cache[0] || (_cache[0] = _createElementVNode("td", null, null, -1))
          ])
        ]))
      }), 128))
    ]),
    _createVNode(NextButton, {
      onClick: openAddressModal,
      text: previousAddresses.value?.length > 0 ? 'Add Another Address' : 'Add an Address'
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode("Add", -1)
      ]))]),
      _: 1
    }, 8, ["text"]),
    (
        _unref(store).state.modal.addressModalActive &&
        _unref(store).state.forms?.stipulation?.id === props.stip?.id
      )
      ? (_openBlock(), _createBlock(AddressFormsModal, {
          key: 0,
          ref_key: "addressFormsModal",
          ref: addressFormsModal,
          onClose: closeAddressModal,
          onSuccess: handleSuccess,
          stip: __props.stip,
          applicant: __props.applicant,
          previousAddresses: previousAddresses.value
        }, null, 8, ["stip", "applicant", "previousAddresses"]))
      : _createCommentVNode("", true)
  ]))
}
}

})